import * as editOrder from './../actions/editOrder';
import { GET_SHIPMENT_BY_ID_FAILS, GET_SHIPMENT_BY_ID_SUCCESS } from './../actions/shipmentAction';
import lang from './../languages/en';
import { alertSuccess } from './../services/dialog';
import { copyData } from './../services/helper';
import { regexJapanese, regexName } from './../services/ruleValidate';
import OrderFromShipment from './helper/helperAddOrderFromShipment';
import EditOrder from './helper/helperEditOrder';
import { informationClassesDefault, informationDefault } from './helper/stateDefaultOrder';
import { SHIPPER_INFOR_SUCCESS } from '../actions/shipperInfor';
import { noPostalCodeValidationCountries } from './../services/fieldRequired';

const stateDefaultAddOrder = () => {
    return {
        request: false,
        confirm_save_order: false,
        search_item_code: false,
        selected_item_code: '',
        row_item: '',
        search_origin: false,
        selected_origin: '',
        checked_all_items: false,
        message: '',
        error: [],
        tooltip: '',
        manual_flag_bl: true,
        check_type_order: false,
        deleteDisable: true,
        restoreBtnDisable: false,
        dumplicateValueItem: 0,
        rowItemError: [],
        buttonEditOrderDisabled: true,
        settingMappingItemName: null,
        dataMappingItem: null,
        modalMappingItem: false,
        modalTypeMappingItem: false,
        buttonAddOrUpdateMapping: true,
        mappingOrderSameSku: 3,
        SKUDuplicateOrderOther: false
    }
}

const initialState = {
    information: informationDefault(),
    shipperInformation: {},
    informationOrigin: informationDefault(),
    classes: informationClassesDefault(),
    items: [],
    isLoading: true,
    itemsOrigin: [],
    ...stateDefaultAddOrder()
}

export default (state = initialState, action) => {
    switch (action.type) {
        case editOrder.CHANGE_INFOR_EDIT_ORDER:
            state.information[action.payload.column] = action.payload.value
            return {
                ...state,
                information: {
                    ...state.information,
                    [action.payload.column]: action.payload.value
                }
            }

        case editOrder.CHANGE_ITEM_EDIT_ORDER:
            return {
                ...state,
                items: [...action.payload]
            }

        case editOrder.CHECKED_ALL_ITEMS_EDIT_ORDER:
            return {
                ...state,
                items: [...action.payload.items],
                checked_all_items: action.payload.checked_all
            }

        case editOrder.CHANGE_CLASSES_EDIT_ORDER:
            return {
                ...state,
                classes: { ...action.payload },
            }

        case editOrder.CHANGE_EDIT_ORDER:
            return {
                ...state,
                [action.payload.column]: action.payload.value,
            }

        case editOrder.SEARCH_ITEM_CODE_EDIT_ORDER:
            return {
                ...state,
                [action.payload.column]: action.payload.value,
                row_item: action.payload.rowItem
            }

        case editOrder.CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS:
            let address = action.payload.data.data

            const { address1, address2, address3, address4 } = state.information
            if (!address1 && !address2 && !address3 && !address4) {
                state.information.address1 = address.Add1
                state.information.address2 = address.Add2
                state.information.address3 = address.Add3
            }

            if (address.Add1 || address.Add2 || address.Add3) {
                state.classes.postal_code = ''
            } else {
                state.classes.postal_code = 'warring'
            }

            if (state.information.address1) {
                state.classes.address1 = ''
            } else {
                state.classes.address1 = 'error'
            }

            if (state.information.address2) {
                state.classes.address2 = ''
            } else {
                state.classes.address2 = 'error'
            }

            return {
                ...state
            }

        case editOrder.CHECK_POSTAL_CODE_EDIT_ORDER_FAILS:
            return {
                ...state,
                isLoading: false
            }

        case editOrder.EDIT_ORDER_SUCCESS:
            let orderRes = action.payload
            let dataOrder = action.payload.data.data.Order
            let dataItems = action.payload.data.data.OrderDetails

            if (orderRes.postalCode) {
                if (!orderRes.postalCode.Add1 && !orderRes.postalCode.Add1 && !orderRes.postalCode.Add1 && !noPostalCodeValidationCountries.includes(dataOrder['DestinationCountryCH'])) {
                    state.classes.postal_code = 'warring'
                } else {
                    state.classes.postal_code = ''
                }
            }

            let fillDataEditOrder = EditOrder(dataOrder, dataItems, state, orderRes)

            return {
                ...fillDataEditOrder.state,
                information: fillDataEditOrder.informationFill,
                informationOrigin: copyData(fillDataEditOrder.informationFill),
                items: copyData(fillDataEditOrder.itemsFill),
                isLoading: false,
                itemsOrigin: copyData(fillDataEditOrder.itemsFill),
                manual_flag_bl: dataOrder['InputFlagIN'],
                channel_order_item_amazon: orderRes['channelOrderItem'],
                check_type_order: false
            }

        case editOrder.UPDATE_ORDER_SUCCESS:
            alertSuccess(lang.order_edit_success)
            return {
                ...state,
                isLoading: false
            }

        case GET_SHIPMENT_BY_ID_SUCCESS:
            let shipmentRes = action.payload
            let shipment = action.payload.data.data.Shipment
            let packages = action.payload.data.data.Shipment.Packages

            if (!shipmentRes.postalCode.Add1 && !shipmentRes.postalCode.Add1 && !shipmentRes.postalCode.Add1) {
                state.classes.postal_code = 'warring'
            } else {
                state.classes.postal_code = ''
            }

            let fillDataCreateOrderFromShipment = OrderFromShipment(shipment, packages, state)
            state.classes.channel_order = 'error'

            return {
                ...fillDataCreateOrderFromShipment.state,
                information: fillDataCreateOrderFromShipment.shipmentNew,
                isLoading: false,
                items: fillDataCreateOrderFromShipment.itemFromPackage
            }

        case editOrder.DELETE_ORDER_FROM_EDIT_ORDER_SUCCESS:
            alertSuccess(lang.delete_order_success)
            return {
                ...state,
                isLoading: false
            }

        case editOrder.ADD_ORDER_FROM_SHIPMENT_FAILS:
            if (action.payload.data.code === 211140) {
                state.classes.channel_order = 'error'
            }

            return {
                ...state,
                isLoading: false
            }

        case editOrder.ADD_ORDER_FROM_SHIPMENT_SUCCESS:
            alertSuccess(lang.create_order_success)
            return {
                ...state,
                isLoading: false
            }

        case editOrder.DELETE_ORDER_FROM_EDIT_ORDER_FAILS:
            return {
                ...state,
                isLoading: false
            }

        case editOrder.UPDATE_ORDER_FAILS:
            if (action.payload.data.code === 211140) {
                state.classes.channel_order = 'error'
            }

            return {
                ...state,
                isLoading: false
            }

        case editOrder.EDIT_ORDER_FAILS:
            return {
                ...state,
                isLoading: false
            }

        case SHIPPER_INFOR_SUCCESS:
            let shipperInfor = action.payload.data.data
            return {
                ...state,
                shipperInformation: {
                    currency: shipperInfor.DefaultCurrencyCH,
                    defaultPaymentTerm: shipperInfor.DefaultPaymentTermCH,
                    paymentTerms: shipperInfor.PaymentTermsCH,
                    destinationCountriesCH: shipperInfor.DestinationCountryCH,
                    handlingChargeFlg: shipperInfor.HandlingChargeFlg,
                    multiPackageFlg: shipperInfor.MultiPackageFlg
                },
            }

        case editOrder.STATE_INFORMATION_DEFAULT_EDIT_ORDER:
            let inforNew = action.payload
            inforNew.terms = ''
            inforNew.preferred_time = ''
            inforNew.currency = ''
            inforNew.country = ''
            inforNew.order_date = null

            return {
                ...state,
                information: inforNew,
                ...stateDefaultAddOrder()
            }

        case editOrder.STATE_INFORMATION_CLASSES_DEFAULT_EDIT_ORDER:
            return {
                ...state,
                classes: action.payload
            }

        case editOrder.CONVERT_NAME_EDIT_ORDER_SUCCESS:
            let dataConvert = action.payload.data.data.ConvertedString

            if (typeof dataConvert === 'string') {
                dataConvert = dataConvert.trim()
            }

            if (!dataConvert || (regexJapanese(dataConvert) || regexName(dataConvert))) {
                state.classes.yomigana = 'error'
            } else {
                state.classes.yomigana = ''
            }

            return {
                ...state,
                information: {
                    ...state.information,
                    yomigana: dataConvert.toUpperCase()
                }
            }

        case editOrder.CONVERT_NAME_EDIT_ORDER_FAILS:
            return {
                ...state
            }

        case editOrder.CANCEL_ROW_EDIT_ORDER:
            let filterChannelOrderItem = copyData(state.itemsOrigin).filter((e, i) => {
                return e.key === action.payload
            })

            state.items.filter((value, key) => {
                if (value.key === filterChannelOrderItem[0]['key']) {
                    state.items[key] = filterChannelOrderItem[0]
                }
                return
            })

            return {
                ...state,
                items: state.items
            }

        case GET_SHIPMENT_BY_ID_FAILS:
            return {
                ...state,
                isLoading: false
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/editOrder.js